import React, { createContext, useContext, useState, useCallback } from 'react';
import { FaCheckCircle, FaExclamationCircle, FaInfoCircle, FaExclamationTriangle } from 'react-icons/fa';

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'info') => {
    const id = Date.now();
    setToasts((prevToasts) => [...prevToasts, { id, message, type }]);
    setTimeout(() => removeToast(id), 3000); // Auto-remove after 3 seconds
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}
      <div className="fixed bottom-4 right-8 space-y-2">
        {toasts.map((toast) => (
          <div
            key={toast.id}
            className={`flex items-center p-4 rounded shadow-lg text-white ${toastStyles[toast.type]}`}
          >
            {getIcon(toast.type)}
            <span className="ml-2">{toast.message}</span>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};

const toastStyles = {
  success: 'bg-green-600',
  error: 'bg-red-500',
  info: 'bg-blue-500',
  warning: 'bg-yellow-500 text-black',
};

const getIcon = (type) => {
  switch (type) {
    case 'success':
      return <FaCheckCircle className="mr-2" />;
    case 'error':
      return <FaExclamationCircle className="mr-2" />;
    case 'info':
      return <FaInfoCircle className="mr-2" />;
    case 'warning':
      return <FaExclamationTriangle className="mr-2" />;
    default:
      return <FaInfoCircle className="mr-2" />;
  }
};